import { createSlotRecipe } from './runtime.js';

const carouselConfig = {"name":"carousel","slots":["root","viewport","container","slide","dots"]}

export const carousel = /* @__PURE__ */ createSlotRecipe(carouselConfig)